<template>
  <div class="comp_content">
    <h5-header :header-msg="headerMsg"></h5-header>

    <van-tabs
      v-model="active"
      swipeable
      title-active-color="#EC130C"
      background="#F5F5F5"
      title-inactive-color="#666"
    >
      <van-tab v-for="(items,index) in complainData" :title="items.title" :key="index">
        <div class="comp_list" v-for="(item,idx) in items.list" :key="idx">
          <p>
            <span>订单号</span>
            <span>{{item.orderSn}}</span>
            <!-- <span>{{item.state != 5?'用户投诉':'用户撤销投诉'}}</span> -->
          </p>
          <div
            :class="{sty:item.state == 5,return_back:item.state != 5}"
          >{{(item.state == '1' || item.state == '2')?'商家处理中': item.state == '5'?'用户撤销投诉，\n该笔订单收益已存入您钱包':'平台已介入'}}</div>
          <div>
            <van-row>
              <van-col span="6">投诉原因</van-col>
              <van-col
                span="18"
                style="text-align:left;"
              >{{item.reason == '1'?'商品不新鲜':item.reason == '2'?'商品质量问题':item.reason == '3'?'骚扰威胁':item.reason == '4'?'商品缺斤少两':'其它'}}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">具体原因</van-col>
              <van-col span="18" style="text-align:left;">{{item.content}}</van-col>
            </van-row>
            <van-row>
              <van-col span="6"></van-col>
              <van-col span="18" style="text-align:left;">
                <img
                  :src="imgPrex+items"
                  alt
                  v-for="(items,idxs) in item.memberUploadImages"
                  :key="idxs"
                  @click="perviewImg(item.memberUploadImages,idxs)"
                />
              </van-col>
            </van-row>
            <van-row>
              <van-col span="6">服务态度</van-col>
              <van-col
                span="18"
                style="text-align:left;"
              >{{item.attitude == '1'?'较好':item.attitude == '2'?'一般':'极其恶劣'}}</van-col>
            </van-row>
            <van-row>
              <van-col span="6">投诉时间</van-col>
              <van-col span="18" style="text-align:left;">{{item.createTime}}</van-col>
            </van-row>
            <van-row v-show="index == 1">
              <van-col span="6">撤诉时间</van-col>
              <van-col span="18" style="text-align:left;">{{item.revokeTime}}</van-col>
            </van-row>

            <div class="businesreply" v-show="item.sellerProcessingResult.length>0">
              <span>商家回复:</span>
              <p>{{item.sellerProcessingResult}}</p>
            </div>
            <div
              class="myreply"
              v-show="item.respondentProcessingResult.length>0 || item.respondentProcessingVideoList.length>0"
            >
              <span>我的回复:</span>
              <p>{{item.respondentProcessingResult}}</p>
              <div class="videos">
                <div v-for="(its,i) in item.respondentProcessingVideoList" :key="i">
                  <img :src="its.coverUrl" alt @click="playUrl(its.vodVideoId)" class="pic" />
                  <img
                    src="../../assets/img/icon_evaluate_play.png"
                    @click="playUrl(its.vodVideoId)"
                    alt
                    class="play"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="btn-group">
            <van-button
              plain
              type="primary"
              color="#EC130C"
              @click="goOrderDetails(item.orderId)"
            >查看订单</van-button>
            <van-button
              type="danger"
              color="#EC130C"
              v-show="item.state == 5"
              @click="goDetails(item.orderId)"
            >处理详情</van-button>
            <van-button
              type="danger"
              color="#EC130C"
              v-show=" item.respondentProcessingResult.length == 0&&item.respondentProcessingVideoList.length == 0 && item.state != 5&&item.state != 4"
              @click="goPage(item.orderComplaintId,item.orderId)"
            >回复</van-button>
          </div>

          <!-- <van-button type="danger" @click="tel" v-show="item.state != 5">查看订单</van-button> -->
          <!-- <a :href="telnum" v-show="show" id="tel">{{phone}}</a> -->
        </div>
        <!-- 缺省页 -->
        <Lack v-if="items.list.length<=0" text="没有投诉哦~"></Lack>
      </van-tab>
    </van-tabs>

    <!-- 视频播放弹窗页 -->
    <van-dialog v-model="showVideo" :showConfirmButton="false" :closeOnClickOverlay="true">
      <video :src="videosrc" controls="controls" width="100%" height="100%"></video>
    </van-dialog>
  </div>
</template>

<script>
import {
  complainList,
  getScoreList,
  getPhone,
  playUrl
} from "@/api/picker/index";
import { ImagePreview } from "vant";
import Lack from "@/components/lack/lack";
export default {
  components: {
    Lack
  },
  data() {
    return {
      headerMsg: {
        title: "投诉记录",
        url: ""
      },
      // complainData: [],
      imgPrex: this.imgPrex,
      show: false,
      phone: "",
      telnum: "",
      complainData: [
        {
          title: "未解决",
          list: []
        },
        {
          title: "已解决",
          list: []
        }
      ],
      active: 0,
      showVideo: false, //视频播放弹窗
      videosrc: "" //视频播放地址
    };
  },
  mounted() {
    this.complainList("0");
    this.complainList("1");
    this.getPhone();
    if (this.GetQueryString("token")) {
      this.$store.commit("user/SET_token", this.GetQueryString("token"));
    }
  },
  methods: {
    complainList(type) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        isRevoke: type //0：未撤销，1：撤销，2表示全部
      };
      complainList(obj).then(res => {
        console.log(res);
        let list = res.content.list;
        // for (let i = 0; i < list.length; i++) {
        //   if (list[i].memberUploadImages != "") {
        //     list[i].imgList = list[i].memberUploadImages.split(",");
        //   } else {
        //     list[i].imgList = [];
        //   }
        // }
        this.complainData[type].title = type == 0 ? "未解决" : "已解决";
        this.complainData[type].list = list;
        console.log(this.complainData);
      });
    },
    perviewImg(images, idx) {
      let list = [];
      for (let i = 0; i < images.length; i++) {
        list.push(this.imgPrex + images[i]);
      }
      ImagePreview({
        images: list,
        startPosition: idx,
        onClose() {
          // do something
        }
      });
    },
    tel() {
      this.$dialog
        .confirm({
          message: this.phone,
          confirmButtonText: "呼叫",
          confirmButtonColor: "#EC130C"
        })
        .then(() => {
          // on confirm
          // console.log(this.$refs.tel.el);
          document.getElementById("tel").click();
        })
        .catch(() => {
          // on cancel
        });
    },
    goDetails(id) {
      this.$router.push({
        path: "/complaintHandDetails",
        query: {
          id,
          type: 0
        }
      }); //跳转
    },
    getPhone() {
      getPhone({
        token: this.$store.getters.token || this.GetQueryString("token")
      }).then(res => {
        this.phone = res.content.phone.split(",")[0];
        this.telnum = "tel:" + res.content.phone.split(",")[0];
      });
    },

    // 获取动态视频地址
    playUrl(id) {
      // console.log("2");
      let obj = {
        vodVideoId: id //点播服务中视频id，cfp_vod_video中的 vod_video_id
      };
      playUrl(obj).then(res => {
        this.showVideo = true;
        this.videosrc = res.content.playUrl;
      });
    },

    // 跳转
    goPage(id, oId) {
      this.$router.push({
        path: "/complaintReply",
        query: {
          id,
          oId
        }
      }); //跳转
    },

    goOrderDetails(id) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goOrderDetails(id);
        } else {
          // ios环境
          window.webkit.messageHandlers.goOrderDetails.postMessage({
            id
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" >
html {
  background: #f5f5f5;
}
</style>
<style lang="scss" scoped>
.comp_content {
  width: 100%;
  height: 100%;
  // margin-top: 10px;
  /deep/.van-tabs {
    .van-tab{
      font-size: 18px;
    }
    /deep/.van-tabs__wrap{
      position: fixed;
      top: 44px;
      width: 100%;
      z-index: 666;
    }
    /deep/.van-tabs__content{
      margin-top: 44px;
    }
  }
  /deep/.van-tab--active {
    font-weight: bold;
  }
  .comp_list {
    position: relative;
    width: 331px;
    min-height: 220px;
    padding: 0 10px 15px;
    height: fit-content;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin: 10px 12px;
    font-size: 17px;
    color: #666666;
    > p {
      width: auto;
      height: 50px;
      margin: 0;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      font-size: 15px;
      > span:first-child {
        color: #666;

        margin-right: 5px;
      }
      > span:nth-child(2) {
        color: #1d1d1d;
        // font-weight: bold;
      }
    }
    > div {
      width: 100%;
      .van-row {
        margin-top: 10px;
        .van-col {
          text-align: left;
          font-size: 15px;
        }
        .van-col:nth-child(2) {
          color: #1d1d1d;
        }
      }
      .businesreply {
        width: auto;
        min-height: 70px;
        padding: 10px;
        background: #f7f4f8;
        text-align: left;
        margin-top: 15px;
        span {
          font-size: 17px;
          color: #144aa7;
          font-weight: bold;
        }
        p {
          font-size: 15px;
          color: #1d1d1d;
          margin: 5px 0 0;
        }
      }
      .myreply {
        width: auto;
        min-height: 70px;
        padding: 10px;
        background: #f7f4f8;
        text-align: left;
        margin-top: 15px;
        span {
          font-size: 17px;
          color: #1d1d1d;
          font-weight: bold;
        }
        p {
          font-size: 15px;
          color: #1d1d1d;
          margin: 5px 0 0;
        }
        .videos {
          display: flex;
          margin-top: 10px;
          div {
            width: 66px;
            height: 66px;
            position: relative;
            margin-right: 3px;
            .pic,
            .play {
              position: absolute;
              left: 0;
            }
            .pic {
              width: 66px;
              height: 66px;
              z-index: 88;
              margin-top: 0;
            }
            .play {
              width: 50px;
              height: 50px;
              z-index: 89;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }
          }
        }
      }
    }
    .return_back {
      height: 24px;
      width: 312px;
      text-align: center;
      padding: 5px 10px;
      // line-height: 41px;
      border-radius: 5px;
      background-color: #fff5f5;
      color: #ec130c;
      font-size: 17px;
      white-space: pre-wrap;
      margin: 10px auto;
    }
    .sty {
      height: 45px;
      width: 312px;
      text-align: center;
      padding: 5px 10px;
      // line-height: 41px;
      border-radius: 5px;
      background-color: #f8fffb;
      color: #118b35;
      font-size: 17px;
      white-space: pre-wrap;
      margin: 10px auto;
    }
    img {
      width: 63px;
      height: 63px;
      border-radius: 5px;
      margin-right: 2px;
      margin-top: 6px;
    }
    // img:first-child {
    //   // margin-left: -10px;
    // }
    // img:last-child {
    //   margin-right: 0;
    // }
    /deep/ .btn-group {
      width: 100%;
      height: auto;
      display: flex;
      margin: 15px auto 0;
      .van-button {
        width: 88px;
        height: 36px;
        border-radius: 5px;
        line-height: 36px;
        // display: initial;
        // margin: 0 0 20px 200px;
      }
      .van-button:first-child {
        margin-left: auto;
      }
      .van-button:nth-child(2),
      .van-button:nth-child(3) {
        margin: 0 10px 0 20px;
      }
    }
  }
  /deep/.van-dialog {
    background: none;
  }
}
</style>

